<template>
    <div class="w-full max-w-500 mx-auto min-h-screen" data-cy="section_history_main">
        <div class="w-full h-full bg-a-blue-f2f5ff fixed top-0 left-0 right-0"></div>
        <HistoryMenu data-cy="component_history_menu" />
        <div class="mt-5 px-4 pb-24 relative" data-cy="container_history_content">
            <HistoryList
                ref="history-list"
                data-cy="list_history_redeem"
                :listConfig="purchaseListConfig"
                :filterConfig="purchaseFilterListConfig"
            ></HistoryList>
        </div>
        <MenuBar />
    </div>
</template>
<script>
import ConfigManager from '@/config/ConfigManager.js';
import Util from '@/helper/Utility.js';
//component
import HistoryMenu from '../component/HistoryMenu/HistoryMenu.vue';
import MenuBar from '@/components/Layout/MenuBar/MenuBar.vue';
import HistoryList from '../component/HistoryRedeem/HistoryList.vue';
//mixin
import AuthPageMixin from '@/mixin/AuthPageMixin.js';
import ModalMixin from '@/mixin/ModalMixin.js';
//service
import {
    PurchaseListConfigBuilder,
    PurchaseFilterConfigBuilder,
} from '@/core/History/config/HistoryConfigModel.js';

export default {
    name: 'History',
    mixins: [ModalMixin, AuthPageMixin],
    components: {
        HistoryMenu,
        MenuBar,
        HistoryList,
    },
    data: function() {
        return {
            purchaseListConfig: null,
            purchaseFilterListConfig: null,
        };
    },
    created: function () {
        this.initialIsFromLanding();
        this.setScrollLoadMore();
        this.setupHistoryList();

        this.tracking.screenName('history');
        this.tracking.event('history_my_reward', 'history_my_reward', null, null);
    },
    mounted: async function() {
        this.modal.loadingModal.show();
        await this.$refs['history-list'].getList();
        this.modal.loadingModal.hide();
    },
    beforeUnmount: function() {
        window.onscroll = null;
    },
    methods: {
        /**
         * Function หลังจากหลับมาจากเว็บ Interface ให้ clear browser history
         */
        initialIsFromLanding: function () {
            let backCount = this.$route.query.back;
            if (Util.isNumber(backCount) && backCount != 0) {
                this.$router.go(backCount);
            }
        },
        //#region mixin
        onSetupModalCompleted: function() {
            this.initialHistoryModal();
        },
        //#endregion mixin
        setScrollLoadMore: function() {
            window.onscroll = () => {
                // 100 คือระยะก่อนถึงจุดล่างสุดของ page
                var scrollOffSet = 100;
                var pageHeight = Math.max(
                    window.pageYOffset,
                    document.documentElement.scrollTop,
                    document.body.scrollTop
                );
                var bottomOfWindow =
                    pageHeight + window.innerHeight >
                    document.documentElement.offsetHeight - scrollOffSet;
                if (bottomOfWindow) {
                    this.loadMore();
                }
            };
        },
        setupHistoryList: async function () {
            //initial config for api.
            var listConfig = new PurchaseListConfigBuilder()
                .setConfigList(ConfigManager.getHistoryPurchaseList())
                .setTop(25)
                .create();
            this.purchaseListConfig = listConfig;

            //initial filter config for api.
            var filterListConfig = new PurchaseFilterConfigBuilder()
                .create();
            this.purchaseFilterListConfig = filterListConfig;
        },

        loadMore: async function() {
            this.modal.loadingModal.show();
            await this.$refs['history-list'].loadMore();
            this.modal.loadingModal.hide();
        },
    },
}
</script>
<style lang="scss" scoped>
</style>
